// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"70fb9d63","331":"6c89a56f"}[chunkId] + ".chunk.js";
};